import { DEFAULT_COLLAPSED_WIDTH, DEFAULT_EXPANDED_WIDTH } from '../constants';

/**
 * This function gets the max width of the search box. If the search box isn't
 * expanded (i.e. user isn't in search session), use custom value provided by
 * consumer (or default value if a custom one wasn't provided). If the search box
 * is expanded, use default max width.
 */
export default function getSearchBoxMaxWidth(
    isSearchBoxExpanded: boolean,
    customCollapsedMaxWidth: number
) {
    /**
     * If search box is fixed width, then return customCollapsedMaxWidth if it
     * exists, or the default value. Whether or not the search box is expanded
     * (i.e. in search mode) doesn't matter because the width is fixed.
     *
     * If the search box isn't fixed width, then return collapsed or expanded
     * width as appropriate based on isSearchBoxExpanded.
     */
    if (!isSearchBoxExpanded) {
        return customCollapsedMaxWidth ? customCollapsedMaxWidth : DEFAULT_COLLAPSED_WIDTH;
    } else {
        return DEFAULT_EXPANDED_WIDTH;
    }
}
